<template>
  <dash-board-layout :active="8" :fulid="true">
    <div class="verification section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Upload your identity</h4>
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" class="identity-upload">
                  <div class="identity-content">
                    <span class="icon"><i class="fa fa-check"></i></span>
                    <h4>Congratulation. Your bank added</h4>
                    <p>
                      Efficiently provide access to installed base core
                      competencies and end end data Interactively target equity.
                    </p>
                  </div>

                  <div class="text-center">
                    <button type="submit" class="btn btn-success pl-5 pr-5">
                      Continue
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
export default {
  components: { DashBoardLayout },
  methods: {
    formSubmit() {
      this.$router.push("/settings-account");
    },
  },
};
</script>
